import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import userService from "../../../services/userService";
import { getUsersSelector } from "../../../state/selectors/User.selectors";
import UserTitle from "./UserTitle";

const SSOUser = (props) => {
  const { ssoId, resolvedSSOData, UserRenderer } = props;

  useEffect(() => {
    userService.register();
    userService.loadUser(ssoId);
  }, []);

  return <UserRenderer {...props} resolvedUser={resolvedSSOData} />;
};

SSOUser.propTypes = {
  UserRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  resolvedSSOData: PropTypes.shape({}),
  ssoId: PropTypes.string,
};

SSOUser.defaultProps = {
  resolvedSSOData: null,
  UserRenderer: UserTitle,
  ssoId: null,
};

const mapStateToProps = (state, props) => {
  const users = getUsersSelector(state) || new Map();
  return { resolvedSSOData: users.get(props.ssoId) };
};

export default connect(mapStateToProps, {})(React.memo(SSOUser));
